<template>
  <v-container class="mt-10">
    <a class="anchor" id="schedule"></a>
    <div class="col text-center">
      <h2 class="text-center text-uppercase">
        <i class="fas fa-square"></i>
        {{ title || $t("schedule") }}
      </h2>
    </div>
    <v-row>
      <v-card width="100%" class="ml-3 mr-3">
        <v-card-title>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            :disabled="currentDay === 0"
            @click="--currentDay"
          >
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          {{ scheduleDays[currentDay] | formatDate }}
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            :disabled="currentDay === Object.keys(schedule).length - 1"
            @click="++currentDay"
          >
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-window v-model="currentDay" vertical reverse>
          <v-window-item v-for="(dailySchedule, date) in schedule" :key="date">
            <v-list width="100%">
              <div
                v-for="(scheduleToday, index) in dailySchedule"
                :key="scheduleToday._id"
              >
                <v-list-item
                  v-if="
                    !scheduleToday.children ||
                      scheduleToday.children.length === 0
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ scheduleToday.startTime | formatTime }} -
                      {{ scheduleToday.endTime | formatTime }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{
                        scheduleLocale === "en" && scheduleToday.title_en
                          ? scheduleToday.title_en
                          : scheduleToday.title
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      color="primary"
                      dark
                      :href="getNonEmbeddableVideoUrl(scheduleToday)"
                      target="_blank"
                      v-if="
                        showVideo && getNonEmbeddableVideoUrl(scheduleToday)
                      "
                    >
                      <v-icon left> mdi-youtube </v-icon>
                      {{ $t("form.btn.video") }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      dark
                      @click="showDetailView(scheduleToday)"
                      v-else-if="showVideo && getVideoUrl(scheduleToday)"
                    >
                      <v-icon left> mdi-youtube </v-icon>
                      {{ $t("form.btn.video") }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      dark
                      @click="showDetailView(scheduleToday)"
                      v-else
                    >
                      {{ $t("form.btn.details") }}
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-list-group v-else>
                  <template #activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ scheduleToday.startTime | formatTime }} -
                        {{ scheduleToday.endTime | formatTime }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{
                          scheduleLocale === "en" && scheduleToday.title_en
                            ? scheduleToday.title_en
                            : scheduleToday.title
                        }}
                      </v-list-item-subtitle>
                      <template v-if="scheduleToday.chairpersons">
                        <v-list-item-subtitle
                          v-for="chairperson in scheduleToday.chairpersons"
                          :key="chairperson.name"
                        >
                          {{ chairperson.name }} ({{ chairperson.company }})
                        </v-list-item-subtitle>
                      </template>
                    </v-list-item-content>
                  </template>
                  <v-list-item
                    v-for="childSchedule in scheduleToday.children"
                    :key="childSchedule._id"
                  >
                    <v-list-item-content class="ml-2">
                      <v-list-item-title>
                        {{ childSchedule.startTime | formatTime }} -
                        {{ childSchedule.endTime | formatTime }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{
                          scheduleLocale === "en" && childSchedule.title_en
                            ? childSchedule.title_en
                            : childSchedule.title
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn
                        color="primary"
                        dark
                        :href="getNonEmbeddableVideoUrl(childSchedule)"
                        target="_blank"
                        v-if="
                          showVideo && getNonEmbeddableVideoUrl(childSchedule)
                        "
                      >
                        <v-icon left> mdi-youtube </v-icon>
                        {{ $t("form.btn.video") }}
                      </v-btn>
                      <v-btn
                        color="primary"
                        dark
                        @click="showDetailView(childSchedule)"
                        v-else-if="showVideo && getVideoUrl(childSchedule)"
                      >
                        <v-icon left> mdi-youtube </v-icon>
                        {{ $t("form.btn.video") }}
                      </v-btn>
                      <v-btn
                        color="primary"
                        dark
                        @click="showDetailView(childSchedule)"
                        v-else
                      >
                        {{ $t("form.btn.details") }}
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-group>
                <v-divider v-if="index < dailySchedule.length - 1"></v-divider>
              </div>
            </v-list>
          </v-window-item>
        </v-window>
      </v-card>
    </v-row>
    <v-dialog
      v-model="detailView"
      min-width="500px"
      max-width="800px"
      flat
      :hide-overlay="showVideo"
    >
      <v-card color="grey lighten-4">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            {{ selectedEvent.startTime | formatTime }} -
            {{ selectedEvent.endTime | formatTime }}
            <span
              class="ml-1"
              v-if="selectedEvent.presentationType"
              v-html="$t(`presentationType.${selectedEvent.presentationType}`)"
            />
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu
            bottom
            left
            offset-y
            v-if="selectedEvent.abstractPdf || selectedEvent.paperPdf"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="selectedEvent.abstractPdf"
                :href="selectedEvent.abstractPdf._url"
                target="_blank"
              >
                <v-list-item-title>Abstract</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedEvent.paperPdf"
                :href="selectedEvent.paperPdf._url"
                target="_blank"
              >
                <v-list-item-title>Paper</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
        <v-card-text class="event-schedule-text">
          <p
            class="display-1 text--primary mt-4"
            v-html="
              scheduleLocale === 'en' && selectedEvent.title_en
                ? selectedEvent.title_en
                : selectedEvent.title
            "
          ></p>
          <v-card-subtitle v-if="selectedEvent.room" class="pa-0">
            <v-icon small>mdi-map-marker</v-icon>
            {{ $t(`room.${selectedEvent.room}`) }}
          </v-card-subtitle>
          <p
            class="body-1 text--primary mt-4"
            v-if="selectedEvent['abstract_' + scheduleLocale]"
            v-html="selectedEvent['abstract_' + scheduleLocale]"
          ></p>
          <v-card
            v-if="selectedEvent.authors && selectedEvent.authors.length"
            class="pa-4"
          >
            <v-row dense v-for="(item, i) in selectedEvent.authors" :key="i">
              <v-col>
                {{ item.author }}
                <v-btn
                  v-if="item.cv"
                  class="ml-1"
                  outlined
                  small
                  primary
                  @click="
                    $set(selectedEvent.authors, i, {
                      ...item,
                      showCV: item.showCV ? false : true,
                    })
                  "
                >
                  <v-icon small left v-if="!item.showCV">mdi-eye</v-icon>
                  <v-icon small left v-else>mdi-eye-off</v-icon>
                  CV
                </v-btn>
              </v-col>
              <v-col v-if="item.companyUrl" class="text-wrap">
                <a :href="item.companyUrl" target="_blank">{{
                  item.company
                }}</a>
              </v-col>
              <v-col v-else>
                {{ item.company }}
              </v-col>
              <v-card v-if="item.showCV" class="my-2 pa-4" outlined>
                {{ item.cv }}
              </v-card>
            </v-row>
          </v-card>
          <iframe
            class="ml-n4 mt-2 schedule-video"
            :src="getVideoUrl(selectedEvent)"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
            v-if="showVideo && getVideoUrl(selectedEvent) && detailView"
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            dark
            @click="detailView = false"
            :class="
              selectedEvent.authors && selectedEvent.authors.length > 0
                ? 'mt-n2'
                : 'mt-n6'
            "
          >
            {{ $t("form.btn.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { webinarScheduleResource, pageTypeResource } from "./../api/resources";
import { i18n } from "../plugins/i18n";
import * as moment from "moment";

export default {
  props: ["showVideo", "room", "title"],
  async mounted() {
    moment.locale(this.scheduleLocale);
    this.pageType = (await pageTypeResource.get()).data.type;
    this.events = (
      await webinarScheduleResource.get("", {
        headers: {
          "x-xsrf-token": this.$cookies.get("oegg-cms.csrf"),
        },
      })
    ).data.results;
    this.updateEventScheduleMap();
  },
  data: () => ({
    currentDay: 0,
    schedule: {},
    scheduleDays: [],
    selectedEvent: {},
    pageType: "",
    events: [],
    detailView: false,
  }),
  computed: {
    scheduleLocale() {
      return i18n.locale;
    },
  },
  methods: {
    showDetailView(scheduleToday) {
      this.selectedEvent = scheduleToday;
      this.detailView = true;
    },
    getVideoUrl(scheduleToday) {
      if (this.scheduleLocale === "en" && scheduleToday.video_en) {
        return scheduleToday.video_en;
      } else if (scheduleToday.video) {
        return scheduleToday.video;
      }
      return null;
    },
    getNonEmbeddableVideoUrl(scheduleToday) {
      if (
        this.scheduleLocale === "en" &&
        scheduleToday.video_en &&
        (scheduleToday.video_en.startsWith("https://vimeo.com/") ||
          scheduleToday.video_en.startsWith("https://www.youtube.com/") ||
          scheduleToday.video_en.startsWith("https://youtu.be/"))
      ) {
        return scheduleToday.video_en;
      } else if (
        scheduleToday.video &&
        (scheduleToday.video.startsWith("https://vimeo.com/") ||
          scheduleToday.video.startsWith("https://www.youtube.com/") ||
          scheduleToday.video.startsWith("https://youtu.be/"))
      ) {
        return scheduleToday.video;
      }
      return null;
    },
    updateEventScheduleMap() {
      const scheduleMap = {};
      const filteredEvents = this.room
        ? this.events.filter((event) => event.room === this.room)
        : this.events;
      filteredEvents.forEach((event) => {
        if (!scheduleMap.hasOwnProperty(event.date)) {
          scheduleMap[event.date] = [];
          this.scheduleDays.push(event.date);
        }
        scheduleMap[event.date].push(event);
      });
      for (let date in scheduleMap) {
        const dailyEvents = scheduleMap[date];
        const parentEvents = [];
        for (let i = 0; i < dailyEvents.length; ++i) {
          for (let j = i + 1; j < dailyEvents.length; ++j) {
            if (
              dailyEvents[i].startTime === dailyEvents[j].startTime &&
              this.pageType !== "ISRM"
            ) {
              const parentEvent =
                dailyEvents[i].endTime > dailyEvents[j].endTime
                  ? dailyEvents[i]
                  : dailyEvents[j];
              parentEvent.children = [];
              parentEvents.push(parentEvent);
            }
          }
        }
        let hierarchicalEvents = [];
        for (let i = 0; i < dailyEvents.length; ++i) {
          if (parentEvents.find((event) => event._id === dailyEvents[i]._id)) {
            hierarchicalEvents.push(dailyEvents[i]);
            continue;
          }
          let inserted = false;
          for (let j = 0; j < parentEvents.length; ++j) {
            if (
              dailyEvents[i].startTime >= parentEvents[j].startTime &&
              dailyEvents[i].endTime <= parentEvents[j].endTime
            ) {
              parentEvents[j].children.push(dailyEvents[i]);
              inserted = true;
              break;
            }
          }
          if (inserted) {
            continue;
          }
          hierarchicalEvents.push(dailyEvents[i]);
        }
        hierarchicalEvents.forEach((event) => {
          if (event.children) {
            event.children = event.children.sort((event1, event2) =>
              event1.startTime > event2.startTime
                ? 1
                : event2.startTime > event1.startTime
                ? -1
                : event1.title.localeCompare(event2.title)
            );
          }
        });
        scheduleMap[date] = hierarchicalEvents.sort((event1, event2) =>
          event1.startTime > event2.startTime
            ? 1
            : event2.startTime > event1.startTime
            ? -1
            : event1.title.localeCompare(event2.title)
        );
      }

      for (let date in scheduleMap) {
        let dailyEvents = scheduleMap[date];
        for (let i = dailyEvents.length - 1; i >= 0; --i) {
          if (dailyEvents[i].categoryId) {
            const endTime = dailyEvents[i].endTime;
            let startTime = dailyEvents[i].startTime;
            for (let j = i - 1; j >= 0; --j) {
              if (dailyEvents[j].categoryId === dailyEvents[i].categoryId) {
                if (dailyEvents[j].endTime === startTime) {
                  startTime = dailyEvents[j].startTime;
                }
              }
            }
            const children = dailyEvents.filter(
              (event, index) =>
                index < i &&
                event.categoryId === dailyEvents[i].categoryId &&
                event.startTime >= startTime &&
                event.endTime <= endTime
            );
            dailyEvents[i] = {
              startTime: startTime,
              endTime: endTime,
              title: dailyEvents[i]._category.title,
              title_en: dailyEvents[i]._category.title_en,
              children: [...children, dailyEvents[i]],
              _category: dailyEvents[i]._category,
            };
            if (
              dailyEvents[i]._category.chairpersons &&
              dailyEvents[i]._category.chairpersons.length
            ) {
              dailyEvents[i].chairpersons =
                dailyEvents[i]._category.chairpersons;
            }
            children.forEach((child) => {
              dailyEvents.splice(dailyEvents.indexOf(child), 1);
              --i;
            });
          }
        }
        dailyEvents = dailyEvents.sort((event1, event2) =>
          event1.startTime > event2.startTime
            ? 1
            : event2.startTime > event1.startTime
            ? -1
            : event1.title.localeCompare(event2.title)
        );
      }

      this.schedule = scheduleMap;
      const today = moment().format("YYYY-MM-DD");
      const todayIndex = this.scheduleDays.findIndex((day) => day === today);
      this.currentDay = Math.max(todayIndex, 0);
    },
  },
  watch: {
    room() {
      this.updateEventScheduleMap();
    },
  },
};
</script>

<style scoped>
.schedule-video {
  width: 100%;
}
</style>
